"use client";

import { useState, useEffect, useCallback } from "react";
import { useSession } from "next-auth/react";

export function usePaperBookmarks() {
  const { status } = useSession();
  const [bookmarkedPmids, setBookmarkedPmids] = useState<Set<string>>(new Set());
  const isLoggedIn = status === "authenticated";

  useEffect(() => {
    if (!isLoggedIn) return;
    fetch("/api/paper-bookmarks")
      .then((r) => r.json())
      .then((data: { pmid: string }[]) => {
        setBookmarkedPmids(new Set(data.map((b) => b.pmid)));
      })
      .catch(() => {});
  }, [isLoggedIn]);

  const togglePaperBookmark = useCallback(
    async (pmid: string) => {
      if (!isLoggedIn) return;

      const isCurrently = bookmarkedPmids.has(pmid);
      // 낙관적 업데이트
      setBookmarkedPmids((prev) => {
        const next = new Set(prev);
        if (isCurrently) next.delete(pmid);
        else next.add(pmid);
        return next;
      });

      try {
        await fetch("/api/paper-bookmarks", {
          method: isCurrently ? "DELETE" : "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ pmid }),
        });
      } catch {
        // 롤백
        setBookmarkedPmids((prev) => {
          const next = new Set(prev);
          if (isCurrently) next.add(pmid);
          else next.delete(pmid);
          return next;
        });
      }
    },
    [isLoggedIn, bookmarkedPmids]
  );

  const isPaperBookmarked = useCallback(
    (pmid: string) => bookmarkedPmids.has(pmid),
    [bookmarkedPmids]
  );

  return { isPaperBookmarked, togglePaperBookmark, isLoggedIn };
}
